import { themeConfig } from '@hvccc/component-library';

export default {
  ...themeConfig,
};
